<template>
  <div class="container container-fluid card vh-100">
    <!-- EN TODOS LOS COMPONENTES (SPINERS Y ERRORES) --> 
    <div v-if="loading" class="spinner-container container-fluid">
      <div class="text-center pt-4">
        <h5>FORMULARIO</h5>
      </div> 
      <Loading-Style/>
    </div>
    <transition name="slide-fade">
      <div v-if="!loading" class="container my-4">
        <div v-if="errors.length && !mostrarForm">
          <div class="text-center pt-6">
            <h5>FORMULARIO</h5>
            <p>El formulario se ha enviado correctamente</p>
          </div>
          <p class="alert alert-danger text-center">
            <ul>
              <li v-for="error in errors" :key="error.mensaje">{{ error.mensaje }}</li>
            </ul>
          </p>
        </div>

        <div v-if="mostrarForm">

          <div class="row">
            <div class="col-md-2">
              <div v-if="mostrarLogo" class="text-center m-auto py-5">
                <img :src="logoStorage" alt="" class="img-logo-company">
              </div>
            </div>

            <div class="col-md-8 d-flex align-items-center">
              <div class="text-center m-auto py-5">
                <h2>{{ formName }}</h2>
              </div>
            </div>
            <div class="col-md-12 text-center">
              <hr class="custom-hr"/>
            </div>

            <div class="col-md-12 align-items-center text-center">
              <h5>FORMULARIO COMPLETADO CORRECTAMENTE</h5>
            </div>
            <div class="col-md-12 text-center mt-4">
              <p>El formulario se ha enviado correctamente</p>
            </div>
            <div class="col-md-12 text-center">
              <hr class="custom-hr"/>
              <button class="btn btn-secondary btn-lg w-25 mt-4" @click="volverFormulario">
                Volver
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
  import { ref, onMounted } from "vue"
  import apiForms from "../../apis/Forms"
  import apiAdmin from "../../apis/Admin"
  import apiStorage from "../../apis/Storage"
  import { handleError } from '../../Utils/StatusHandler'
  import { useRouter } from 'vue-router'

  export default {
    name: "FormView",
    setup() {
      const loading = ref(true);
      const mostrarForm = ref(false);
      const errors = ref([]);
      const alert = ref([]);
      const mostrarLogo = ref(false);
      const id = ref('');
      const slugId = ref('');
      const formName = ref(null);
      const logoStorage = ref('');
      const dataCompany = ref([]);
      const dataCompaniesForms = ref([]);
      const dataFormsField = ref([]);
      const dataCompanyId = ref(null);
      const dataCompanyFormId = ref(null);
      const dataCompanyFormName = ref(null);
      const datosFormPublic = ref({});
      const customInput = ref([]);
      const router = useRouter()

      const handleErrors = (error) => {
        handleError(error, { errors });
      };

      const handleLogoError = (error) => {
        console.error('Error al obtener la URL del logotipo:', error);
        mostrarForm.value = true;
      };

      const volverFormulario = () => {
        router.push(`/` + slugId.value + `/formularios/` + id.value)
      };

      const datosFormulario = async () => {
        errors.value = [];

        try { 
          const params = {
            slug: slugId.value,
            id: id.value,
          };

          const response = await apiForms.getForms(params);
          if (response) {

            dataCompany.value = response.data.company;

            dataCompaniesForms.value = dataCompany.value.companiesForms[0];
   
            customInput.value = Object.keys(dataCompaniesForms.value)
              .filter(key => key.startsWith('custom_') && dataCompaniesForms.value[key] !== null && dataCompaniesForms.value[key] !== '')
              .map((key) => ({
                key,
                value: dataCompaniesForms.value[key],
              }));
            
            formName.value = dataCompaniesForms.value.form_name;
            dataCompanyFormId.value = dataCompaniesForms.value.id;
            dataCompanyFormName.value = dataCompaniesForms.value.form_name;
            dataCompanyId.value = dataCompaniesForms.value.company_id;
            
            mostrarForm.value = true;
            updateLogo();
          } else {
            mostrarForm.value = false;
            console.error('No se encontraron datos en la respuesta.');
          }
        } catch (error) {
          handleErrors(error);
          mostrarForm.value = false;
        } finally {
          loading.value = false;
        }
      };

      const updateLogo = async () => {
        try {
          const pathLogo = dataCompany.value.logoPath;
          if (pathLogo) {

            const url = apiStorage.imagesPath(pathLogo);
            logoStorage.value = url;
            mostrarLogo.value = true;
          }
        } catch (error) {
          console.error(error);
          handleLogoError(error);
        }
      };

      const getFormsFieldAll = async () => {
        const response = await apiAdmin.getFormsField();
        dataFormsField.value = response;
      }

      onMounted(() => {
        datosFormulario();
        getFormsFieldAll()
      });

      return {
        loading,
        mostrarForm,
        mostrarLogo,
        errors,
        alert,

        id,
        slugId,
        formName,
        logoStorage,

        dataCompany,
        dataCompaniesForms,
        dataFormsField,
        datosFormPublic,
        customInput,
        dataCompanyId,
        dataCompanyFormId,
        dataCompanyFormName,

        handleLogoError,
        updateLogo,

        volverFormulario
      };
    },
    created() {
      this.slugId = this.$route.params.slug;
      this.id = this.$route.params.id;
    },
  };
</script>